import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useBookmark } from 'common/contexts/react/bookmark-context';
import { useReportLayoutManager } from 'common/contexts/react/report-layout-manager-context';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { useCustomEvents } from 'common/contexts/react/custom-events-context';
import { useNavigateHash } from 'common/contexts/react/react-router';
import { useMetrics } from 'common/contexts/react/metrics-resource-context';
import { useReportEditorActions } from 'common/contexts/react/report-editor-actions-context';
import { useQueryContextManager } from 'common/contexts/react/query-context-manager';
import { useContentSidenavContext } from 'common/widgets/content-sidenav/context';
import { useTranslation } from 'common/i18n/hooks';
import { useNavManager } from 'common/contexts/react/nav-manager';
import { InsightsApp } from './insights-app';
export const InsightsAppContainer = React.forwardRef<InsightsApp>((_props, ref) => {
  const bookmark = useBookmark();
  const customEventsStore = useCustomEvents();
  const currentProject = useCurrentProject();
  const location = useLocation();
  const i18n = useTranslation();
  const metrics = useMetrics();
  const navigate = useNavigateHash();
  const queryContextManager = useQueryContextManager();
  const reportEditorActions = useReportEditorActions();
  const reportLayoutManager = useReportLayoutManager();
  const contentSidenavContext = useContentSidenavContext();
  const navManager = useNavManager();
  return <InsightsApp ref={ref} bookmarkStore={bookmark} currentProject={currentProject} customEventsStore={customEventsStore} i18n={i18n} location={location} metrics={metrics} navigate={navigate} queryContextManager={queryContextManager} reportEditorActions={reportEditorActions} reportLayoutManager={reportLayoutManager} contentSidenavContext={contentSidenavContext} navManager={navManager} />;
});

// for lazy loading route
// eslint-disable-next-line import/no-default-export
export default InsightsAppContainer;